import { API } from "aws-amplify";

import { getAPIReq } from "data/libs/authLib";

import toGlobalId from "./helper";

export const getViews = async (hubId, includeStats = true) => {
  const req = await getAPIReq(
    {
      query: `query getViews {
        views(includeStats: ${includeStats}) {
          edges {
            node {
              id
              uuid
              name
              description
              order
              color
              numActiveClients
              numActiveClientWorkflows
              numRed
              numYellow
              numGreen
            }
          }
        }
      }      
        `,
    },
    { hub: hubId }
  );
  const {
    data: { views },
  } = await API.post("HublyAPI", `/graphql`, req);

  return views.edges.map(({ node }) => {
    return {
      ...node,
      id: node.uuid,
    };
  });
};

export const getView = async (hubId, viewId) => {
  const req = await getAPIReq(
    {
      query: `query getView($viewId: ID!) {
        view(id: $viewId) {
          uuid
          name
          color
          viewWorkflows {
            edges {
              node {
                uuid
                name
                numActiveClientWorkflows
                hasWorkflowRules
                canEdit
                process {
                  uuid
                  name
                  color
                  description
                }
                clientTileOptions {
                  showProgress
                  showIcons
                  showStreams
                  numberOfTasks
                  presentWorkflowName
                  presentStartDate
                }
              }
            }
          }
          filter {
            uuid
            assigneeFilterType
            assigneeFilter
            filterEmptyWorkflows
            filterNextTaskForAssignee
            filterAssigneeIncludeServiceRole
            filterServiceRoleUnassignedOnly
            showAll
            tagFilterType
            tags {
              edges {
                node {
                  uuid
                  name
                }
              }
            }
            reminderTypes
            streamFilterType
            streams {
              edges {
                node {
                  uuid
                  name
                  color
                }
              }
            }
            clients {
              edges {
                node {
                  uuid
                  firstName
                  lastName
                }
              }
            }
          }
        }
      }`,
      variables: {
        viewId: toGlobalId("View", viewId),
      },
    },
    { hub: hubId }
  );
  const {
    data: { view },
  } = await API.post("HublyAPI", `/graphql`, req);

  if (view === null) {
    throw new Error(
      "Failed to load the view, it does not exist within this hub."
    );
  }

  return [
    {
      ...view,
      id: view.uuid,
      filters: {
        ...view.filter,
        id: view.filter.uuid,
        assignee: view.filter.assigneeFilter,
        tags: view.filter.tags.edges.map(({ node: tNode }) => {
          return {
            ...tNode,
            id: tNode.uuid,
          };
        }),
        streams: view.filter.streams.edges.map(({ node: sNode }) => {
          return {
            ...sNode,
            id: sNode.uuid,
          };
        }),
        clients: view.filter.clients.edges.map(({ node: cNode }) => {
          return {
            ...cNode,
            id: cNode.uuid,
            name: `${cNode.firstName} ${cNode.lastName}`.trim(),
          };
        }),
      },
      workflows: view.viewWorkflows.edges.map(({ node: wNode }) => {
        return {
          ...wNode,
          id: wNode.uuid,
          process: wNode.process
            ? { ...wNode.process, id: wNode.process.uuid }
            : null,
        };
      }),
    },
  ];
};

export default getViews;
